import StartNode from "./startNode";
import MessageNode from "./messageNode";
import SingleBlockNode from "./singleBlockNode";
import MenuNode from "./menuNode";
import ButtonNode from "./buttonNode";
import ButtonPixNode from "./buttonPixNode";
import ListNode from "./listNode";
import InputNode from "./inputNode";
import IntervalNode from "./intervalNode";
import ConditionNode from "./conditionNode";
import RandomizerNode from "./randomizerNode";
import TicketNode from "./ticketNode";
import TagNode from "./tagNode";
import RemoveTagNode from "./removeTagNode";
import SwitchFlowNode from "./switchFlowNode";
import AttendantNode from "./attendantNode";
import CampaignProNode from "./campaignProNode";
import HttpRequestNode from "./httpRequestNode";
import VariableNode from "./variableNode";
import OpenaiNode from "./openaiNode";
import GeminiNode from "./geminiNode";
import ImgNode from "./imgNode";
import AudioNode from "./audioNode";
import VideoNode from "./videoNode";
import IxcBuscarClienteNode from "./ixcBuscarClienteNode";
import IxcBuscarFaturaNode from "./ixcBuscarFaturaNode";
import IxcDesbloquearNode from "./ixcDesbloquearNode";

/**
 * Mapa de tipos de node para seus componentes React.
 * A chave deve coincidir com node.type salvo no banco.
 */
export const nodeTypes = {
  start: StartNode,
  message: MessageNode,
  singleBlock: SingleBlockNode,
  menu: MenuNode,
  button: ButtonNode,
  buttonPix: ButtonPixNode,
  list: ListNode,
  input: InputNode,
  interval: IntervalNode,
  condition: ConditionNode,
  randomizer: RandomizerNode,
  ticket: TicketNode,
  tag: TagNode,
  removeTag: RemoveTagNode,
  switchFlow: SwitchFlowNode,
  attendant: AttendantNode,
  campaignPro: CampaignProNode,
  httpRequest: HttpRequestNode,
  variable: VariableNode,
  openai: OpenaiNode,
  gemini: GeminiNode,
  img: ImgNode,
  audio: AudioNode,
  video: VideoNode,
  ixcBuscarCliente: IxcBuscarClienteNode,
  ixcBuscarFatura: IxcBuscarFaturaNode,
  ixcDesbloquear: IxcDesbloquearNode,
};

/**
 * Categorias para a paleta lateral do FlowBuilder.
 * Cada categoria agrupa tipos de nodes para facilitar a selecao.
 */
export const NODE_CATEGORIES = [
  {
    label: "Inicio",
    color: "#3aba38",
    nodes: [
      { type: "start", label: "Inicio", icon: "RocketLaunch" },
    ],
  },
  {
    label: "Mensagens",
    color: "#555",
    nodes: [
      { type: "message", label: "Mensagem", icon: "Message" },
      { type: "singleBlock", label: "Conteudo", icon: "LibraryBooks" },
      { type: "img", label: "Imagem", icon: "Image" },
      { type: "audio", label: "Audio", icon: "MicNone" },
      { type: "video", label: "Video", icon: "Videocam" },
    ],
  },
  {
    label: "Interacao",
    color: "#683AC8",
    nodes: [
      { type: "menu", label: "Menu", icon: "DynamicFeed" },
      { type: "button", label: "Botoes", icon: "SmartButton" },
      { type: "buttonPix", label: "Botao PIX", icon: "Pix" },
      { type: "list", label: "Lista", icon: "ViewList" },
      { type: "input", label: "Captura de Entrada", icon: "TextFields" },
    ],
  },
  {
    label: "Logica",
    color: "#F57C00",
    nodes: [
      { type: "condition", label: "Condicao", icon: "ImportExport" },
      { type: "randomizer", label: "Randomizador", icon: "Casino" },
      { type: "interval", label: "Intervalo", icon: "AccessTime" },
      { type: "switchFlow", label: "Trocar Fluxo", icon: "AccountTree" },
    ],
  },
  {
    label: "Acoes",
    color: "#1565C0",
    nodes: [
      { type: "ticket", label: "Transferir Fila", icon: "ConfirmationNumber" },
      { type: "tag", label: "Adicionar Tag", icon: "Label" },
      { type: "removeTag", label: "Remover Tag", icon: "LabelOff" },
      { type: "attendant", label: "Atendente", icon: "SupportAgent" },
      { type: "campaignPro", label: "Campanha Pro", icon: "Campaign" },
    ],
  },
  {
    label: "Integracao",
    color: "#0277BD",
    nodes: [
      { type: "httpRequest", label: "Requisicao HTTP", icon: "Http" },
      { type: "variable", label: "Variavel", icon: "DataObject" },
    ],
  },
  {
    label: "Inteligencia Artificial",
    color: "#10A37F",
    nodes: [
      { type: "openai", label: "OpenAI", icon: "Psychology" },
      { type: "gemini", label: "Gemini", icon: "AutoAwesome" },
    ],
  },
  {
    label: "IXC Provedor",
    color: "#0D47A1",
    nodes: [
      { type: "ixcBuscarCliente", label: "Buscar Cliente", icon: "PersonSearch" },
      { type: "ixcBuscarFatura", label: "Buscar Fatura", icon: "Receipt" },
      { type: "ixcDesbloquear", label: "Desbloquear", icon: "LockOpen" },
    ],
  },
];

export default nodeTypes;
